import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { BrandingProvider } from './contexts/BrandingContext';
import RoleRoute from './components/RoleRoute';

// Pages
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import CustomerApp from './pages/customer/CustomerApp';
import AdminApp from './pages/admin/AdminApp';
import DriverApp from './pages/driver/DriverApp';

function App() {
  return (
    <AuthProvider>
      <BrandingProvider>
        <Router>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            
            {/* Protected Routes based on Role */}
            <Route path="/app/*" element={<RoleRoute role="customer"><CustomerApp /></RoleRoute>} />
            <Route path="/admin/*" element={<RoleRoute role="admin"><AdminApp /></RoleRoute>} />
            <Route path="/driver/*" element={<RoleRoute role="driver"><DriverApp /></RoleRoute>} />
            
            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </BrandingProvider>
    </AuthProvider>
  );
}

export default App;